import { render } from "./slates.vue?vue&type=template&id=4cdaaed7"
import script from "./slates.vue?vue&type=script&lang=js"
export * from "./slates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__